export default __webpack_public_path__ + "static/media/ManCheckTab.9c128de5.jpg";